<div class="row header-container featureCss">
  @if (isLoggedIn) {
    <div class="col-6 col-md-6 col-lg-6 col-xl-6">
      <div class="row header-section">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 after">
          <img class="header-logo" alt="header" src="{{pathVal}}Signify-logo-1.png">
          <span id="header-home-button" (click)="home()" (keydown.enter)="home()" (keydown.space)="home(); $event.preventDefault()" class="home-img">Home</span>
        </div>
        @if (isRemoved) {
          <div class="col-1 custom-sign">|</div>
        }
        @if (isRemoved) {
          <div class="col-1 custom-text signifyBookmd">Mode</div>
        }
        @if (isRemoved) {
          <div class="col-3 col-md-3 col-lg-3 col-xl-3 signifyBookmd">
            <select id="header-mode-select" class="select-custom" (change)="changeMode($event.target.value)" [(ngModel)]="firstMode">
              @for (version of modes; track version) {
                <option [value]="version" class="info-mode"
                  [attr.id]="version === 'Advanced' ? 'header-mode-option-advanced' : (version === 'Standard' ? 'header-mode-option-standard' : null)">
                  {{ version }}
                </option>
              }
            </select>
          </div>
        }
      </div>
    </div>
  }

  @if (!isLoggedIn) {
    <div class="col-3 col-md-3 col-lg-3 col-xl-3 no-padding">
      <div class="row header-section">
        <div class="col-12 col-md-12 col-lg-12 col-xl-12 after">
          <img class="header-logo" alt="logo" src='{{pathVal}}Signify-logo-1.png'>
          <span [id]="'header-home-button'" (click)="home()" (keydown.enter)="home()" (keydown.space)="home(); $event.preventDefault()" class="home-img">Home</span>
        </div>
      </div>
    </div>
  }
  <div [ngClass]="{'col-6 col-md-6 col-lg-6 col-xl-6 padding-left-landing': isLoggedIn, 'col-9 col-md-9 col-lg-9 col-xl-9 padding-left-login': !isLoggedIn}"
    class="profile-container">
    <div [ngClass]="{'login-margin': !isLoggedIn}">
      @if (isLoggedIn) {
        <span id="header-reader-info" class="reader-info" (click)="getDevieList()" (keydown.enter)="getDevieList()" (keydown.space)="getDevieList(); $event.preventDefault()">{{readerInfo.readerType}}
          ({{readerInfo.message}})
          @if (readerInfo.readerConnected) {
            <img id="header-reader-connected-icon" class="connected-icon"
              src="{{pathVal}}connected-original-icon.png" alt="connected">
          }
          @if (!readerInfo.readerConnected) {
            <img id="header-reader-disconnected-icon" class="connected-icon"
              src="{{pathVal}}disconnected-orginal-icon.png" alt="disconnected">
          }
        </span>
      }
      @if (!isLoggedIn) {
        <span (click)="login()" (keydown.enter)="login()" (keydown.space)="login(); $event.preventDefault()" class="login-placeholder">Log On <img class="profile-icon"
          src="{{pathVal}}Profile-icon.png" alt="icon">
        </span>
      }
      @if (isLoggedIn) {
        <span class="header-dropdown-anchor">
          <button id="header-user-profile-button" type="button" class="profile-button" data-toggle="dropdown" (click)="toggleLogoutMenu($event)" (keydown.enter)="toggleLogoutMenu($event)" (keydown.space)="toggleLogoutMenu($event); $event.preventDefault()">{{getUserName()}}
            <img class="profile-icon" src="{{pathVal}}Profile-icon.png" alt="profile">
          </button>
          <div class="dropdown-menu logout-menu" #logoutMenu [class.show]="isLogoutMenuOpen">
        <div id="header-logout-button" class="user-pre-logout signifyBookmd" data-toggle="collapse" (click)="logout()" (keydown.enter)="logout()" (keydown.space)="logout(); $event.preventDefault()">Logout</div>
        <div class="back-arrow" (click)="goBack();" (keydown.enter)="goBack();" (keydown.space)="goBack();; $event.preventDefault()"><img class="back-arrow-img"
        src="{{pathVal}}B-back-arrow-icon.png" alt="arrow"></div>
        <!--User Preferences Start-->
        <div class="user-pre-link signifyBookmd " id="preferences-menu" data-toggle="dropdown"
        aria-haspopup="true" [attr.aria-expanded]="isPreferencesMenuOpen" (click)="togglePreferencesMenu($event)" (keydown.enter)="togglePreferencesMenu($event)" (keydown.space)="togglePreferencesMenu($event); $event.preventDefault()">Preferences</div>
        <div class="dropdown-menu navModal" aria-labelledby="preferences-menu" [class.show]="isPreferencesMenuOpen" (click)="userPref($event)" (keydown.enter)="userPref($event)" (keydown.space)="userPref($event); $event.preventDefault()">

          <label class="label-checkbox" aria-hidden="true">
            <input type="checkbox" name="savedcffile" class="secondary-checkbox" id="savedcffile"
              [checked]="isDCFSaveFileChecked" (change)="onChangeDCFFile($event.target.checked,'dcffile')"
              aria-label="Save file as DCF(Device Configuration File)" />
              <span id="preferences-option-dcffile" class="dropDown-menu border-extra"></span>
            </label>
            <div id="preferences-option-dcffile-text" class="col-md-10 user-Pref signifyBookmd"> Save file as DCF(Device Configuration File)</div>


            <label class="label-checkbox" aria-hidden="true">
              <input type="checkbox" name="savefeaturefile" class="secondary-checkbox" id="savefeaturefile"
                [checked]="isFeatureSaveFileChecked"
                (change)="onChangeSaveFeatureFile($event.target.checked,'savefeaturefile')"
                aria-label="Save file as feature file" />
                <span id="preferences-option-featurefile" class="dropDown-menu border-extra"></span>
              </label>
              <div class="col-md-10 user-Pref signifyBookmd"> Save file as Feature file</div>


              <label class="label-checkbox" aria-hidden="true">
                <input type="checkbox" name="omitPopup" class="secondary-checkbox" id="omitPopup"
                  [checked]="isOmitChecked" (change)="onPreChange($event.target.checked,'omit')"
                  aria-label="Hide device Info popup" />
                  <span id="preferences-option-hidepopup" class="dropDown-menu border-extra"></span>
                </label>
                <div class="col-md-10 user-Pref signifyBookmd"> Hide device info popup</div>

                <label class="label-checkbox" aria-hidden="true">
                  <input type="checkbox" name="configurationMode" class="secondary-checkbox"
                    [checked]="isconfigurationModeChecked" id="configurationMode"
                    (change)="configurationModeChange($event.target.checked,'configurationMode');"
                    aria-label="Remember last mode (Standard/Advanced)" />
                    <span id="preferences-option-remembermode" class="dropDown-menu border-extra"></span>
                  </label>
                  <div class=" col-md-10 user-Pref signifyBookmd">Remember last mode (Standard/Advanced)</div>

                  <label class="label-checkbox" aria-hidden="true">
                    <input type="checkbox" name="sortedCol" class="secondary-checkbox" [checked]="isSortedChecked"
                      id="sortedCol" (change)="sortedCol($event.target.checked,'sortedCol');"
                      aria-label="Remember last sorted columns" />
                      <span id="preferences-option-sortedcol" class="dropDown-menu border-extra"></span>
                    </label>
                    <div class=" col-md-10 user-Pref signifyBookmd">Remember last sorted columns</div>

                    <label class="label-checkbox" aria-hidden="true">
                      <input type="checkbox" name="visibleColumns" class="secondary-checkbox"
                        [checked]="isVisibleChecked" id="visibleColumns"
                        (change)="visibleColumns($event.target.checked,'visibleColumns');"
                        aria-label="Remember last selected columns" />
                        <span id="preferences-option-visiblecols" class="dropDown-menu border-extra"></span>
                      </label>
                      <div class=" col-md-10 user-Pref signifyBookmd">Remember last selected columns</div>

                      <label class="label-checkbox" aria-hidden="true">
                        <input type="checkbox" name="visiblFilter" class="secondary-checkbox"
                          [checked]="isFilterChecked" id="visiblFilter"
                          (change)="visiblFilter($event.target.checked,'visiblFilter');"
                          aria-label="Remember last selected filter" />
                          <span id="preferences-option-visiblefilter" class="dropDown-menu border-extra"></span>
                        </label>
                        <div class=" col-md-10 user-Pref signifyBookmd">Remember last selected filter</div>

                        <label class="label-checkbox" aria-hidden="true">
                          <input type="checkbox" name="multipleDevicesDevices" class="secondary-checkbox"
                            [checked]="isMultipleDevicesChecked" id="multipleDevices"
                            (change)="multipleDevices($event.target.checked,'multipleDevices');"
                            aria-label="Consecutive configuration of multiple devices" />
                            <span id="preferences-option-ConsecutiveConfig" class="dropDown-menu border-extra"></span>
                          </label>
                          <div class=" col-md-10 user-Pref signifyBookmd">Consecutive configuration of multiple devices </div>
                        </div>
                      </div>
                        </span>
                      }
                      <!--User Preferences End-->
                      <span class="header-dropdown-anchor">
                        @if (isLoggedIn) {
                          <button type="button" class="profile-button" data-toggle="dropdown" (click)="toggleSecondaryMenu($event)" (keydown.enter)="toggleSecondaryMenu($event)" (keydown.space)="toggleSecondaryMenu($event); $event.preventDefault()">
                            @if (isLoggedIn) {
                              <img class="menuIconCss" alt="pathVal" src="{{pathVal}}Menu-icon.png">
                            }
                          </button>
                        }
                        @if (isLoggedIn) {
                          <div class="dropdown-menu logout-menu-2" [class.show]="isSecondaryMenuOpen">
                            <div class="col-md-10 user-Pref signifyBookmd ml-0" (click)="fileConverterLogin()" (keydown.enter)="fileConverterLogin()" (keydown.space)="fileConverterLogin(); $event.preventDefault()"><span
                            class="txt">MultiOne feature file converter</span></div>
                            <div class="col-md-10 user-Pref signifyBookmd ml-0" (click)="webShopLogin()" (keydown.enter)="webShopLogin()" (keydown.space)="webShopLogin(); $event.preventDefault()"><span
                            class="txt">Sample web shop</span></div>
                            <div class="col-md-10 user-Pref signifyBookmd ml-0" (click)="designInLogin()" (keydown.enter)="designInLogin()" (keydown.space)="designInLogin(); $event.preventDefault()"><span class="txt">Easy
                            Design-In Tool</span></div>
                            <div class="col-md-10 user-Pref signifyBookmd ml-0" (click)="oEMLogin()" (keydown.enter)="oEMLogin()" (keydown.space)="oEMLogin(); $event.preventDefault()"><span
                              class="txt">Signify
                            MyLighting</span></div>
                          </div>
                        }
                      </span>
                    </div>
                  </div>
                </div>
